module.exports = __webpack_public_path__ + "img/biaoqian_dianshitai.d85086e1.png";